import React from 'react';
import styled from 'styled-components';
import { PrimaryButton } from 'styleguide/Buttons';
import { Modal, ModalTitle, zIndex } from 'styleguide/Modal';
import { P2 } from 'styleguide/Texts';
import { Spacing } from 'styleguide/spacing';
import { View } from 'styleguide/View';

const Container = styled(View)`
  overflow: hidden;
  gap: ${Spacing.md}px;
`;

const UpperContainer = styled(View)`
  align-items: center;
  gap: ${Spacing.md}px;
`;

export interface OkModalProps {
  title: string;
  subtitle: string;
  submitButtonTitle: string;
  isOpen: boolean;
  onClose: () => void;
}

export const OkModal = ({ title, subtitle, submitButtonTitle, isOpen, onClose }: OkModalProps) => {
  return (
    <Modal
      onClose={onClose}
      overlayStyle={{ zIndex: zIndex.modalOverlay }}
      isOpen={isOpen}
      contentStyle={{ padding: Spacing.lg }}
    >
      <Container>
        <UpperContainer>
          <ModalTitle title={title} onClose={onClose} />
          <P2 type="secondary">{subtitle}</P2>
        </UpperContainer>
        <PrimaryButton title={submitButtonTitle} onClick={onClose} />
      </Container>
    </Modal>
  );
};
